import { render, staticRenderFns } from "./FBPreviewVoucher.vue?vue&type=template&id=2b7d8dd2&scoped=true&"
import script from "./FBPreviewVoucher.vue?vue&type=script&lang=js&"
export * from "./FBPreviewVoucher.vue?vue&type=script&lang=js&"
import style0 from "./FBPreviewVoucher.vue?vue&type=style&index=0&id=2b7d8dd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7d8dd2",
  null
  
)

export default component.exports